<template>
  <div class="popup-wrapper" @click.self="group1.close">
    <form @submit.prevent>
      <div class="popup-action">
        <div class="button button-submit">
          <button class="btn" type="submit" name="QA_display_settings"
            @click="group1.submit"
          >決定
          </button>
        </div>
        <div class="button button-close">
          <button class="btn" @click="group1.close">
            <FontawesomeIcon :icon="['fal','times']" size="lg" class="icn" />
          </button>
        </div>
      </div>
      <div class="popup-container">
        <div class="popup">
          <div class="popup-title">
            <span class="popup-title-main">表示設定</span>
          </div>
          <div class="popup-content">
            <div class="popup-content-1">
              <span class="txt">1ページの表示件数</span>
              <div class="formparts select"
                v-click-outside="() => { group1.visibleSelect = false }"
                :class="{ 'is-visible-list': group1.visibleSelect }"
              >
                <div @click="group1.visibleSelect = !group1.visibleSelect"
                  class="select-label" role="select">
                  {{ group1.list_per_page }}
                  <FontawesomeIcon :icon="group1.visibleSelect ? 'angle-up' : 'angle-down'" class="icn" />
                </div>
                <div class="select-option">
                  <ul class="select-option-list">
                    <li role="option">
                      <label><input type="radio" 
                        v-model.number="group1.list_per_page" 
                        @change="group1.visibleSelect = false"
                        value="30" 
                        group="qa_search_display_settings_num">30</label>
                    </li>
                    <li role="option">
                      <label><input type="radio" 
                        v-model.number="group1.list_per_page" 
                        @change="group1.visibleSelect = false"
                        value="50" 
                        group="qa_search_display_settings_num">50</label>
                    </li>
                    <li role="option">
                      <label><input type="radio" 
                        v-model.number="group1.list_per_page" 
                        @change="group1.visibleSelect = false"
                        value="100" 
                        group="qa_search_display_settings_num">100</label>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <ul class="popup-list">
              <li class="popup-list-item">
                <div class="formparts checkbox is-disable">
                  <input v-model="group1.list_display_keys" value="title" type="checkbox" id="display_settings_00">
                  <label for="display_settings_00">タイトル<FontawesomeIcon icon="check" class="icn" /></label>
                </div>
              </li>
              <li class="popup-list-item">
                <div class="formparts checkbox">
                  <input v-model="group1.list_display_keys" value="text" type="checkbox" id="display_settings_01">
                  <label for="display_settings_01">本文<FontawesomeIcon icon="check" class="icn" /></label>
                </div>
              </li>
              <li class="popup-list-item">
                <div class="formparts checkbox">
                  <input v-model="group1.list_display_keys" value="current" type="checkbox" id="display_settings_02">
                  <label for="display_settings_02">内容現在<FontawesomeIcon icon="check" class="icn" /></label>
                </div>
              </li>
              <li class="popup-list-item">
                <div class="formparts checkbox">
                  <input v-model="group1.list_display_keys" value="note" type="checkbox" id="display_settings_03">
                  <label for="display_settings_03">ノート<FontawesomeIcon icon="check" class="icn" /></label>
                </div>
              </li>
              <li class="popup-list-item">
                <div class="formparts checkbox">
                  <input v-model="group1.list_display_keys" value="book" type="checkbox" id="display_settings_05">
                  <label for="display_settings_05">書籍名<FontawesomeIcon icon="check" class="icn" /></label>
                </div>
              </li>
            </ul>          
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import { defineComponent, reactive, ref, computed } from '@vue/composition-api'
import ClickOutside from 'vue-click-outside'

import * as logicQASearchDisplaySetting from '@/logic/qa/QASearchDisplaySetting'

export default defineComponent({
  directives: {
    ClickOutside
  },
  setup (props, context) {

    const group1 = logicQASearchDisplaySetting.getGroup(props, context)

    return {
      group1
    }
  }
})
</script>

<style lang="scss" scoped>
  .popup-content {
    &-1 {
      padding: 20px;
      display: flex;
      align-items: center;
      border-bottom: 1px solid $color-line;
      position: relative;
      z-index: 2;
      .txt {
        display: inline-block;
        font-size: 1.4rem;
      }
      .formparts.select {
        font-size: 1.4rem;
        min-width: 140px;
        margin-left: 20px;
        input[type="text"] {
          width: 140px;
          padding-right: 40px;
        }
      }
    }
  }
  .popup-list {
    position: relative;
    z-index: 1;
  }
</style>
